export default {
  placeholder: '请输入内容',
  insertImage: '插入图片',
  insertVideo: '插入视频',
};
